module.exports = {
  EARTH_RADIUS_IN_KM: 6371,
};
